exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, ".FormView__text-input--1eZje {\r\n  width: 200px !important;\r\n}\r\n\r\n.FormView__form-field--2w24s {\r\n  width: fit-content;\r\n}\r\n", "",{"version":3,"sources":["FormView.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB","file":"FormView.css","sourcesContent":[".text-input {\r\n  width: 200px !important;\r\n}\r\n\r\n.form-field {\r\n  width: fit-content;\r\n}\r\n"]}]);

// Exports
exports.locals = {
	"text-input": "FormView__text-input--1eZje",
	"textInput": "FormView__text-input--1eZje",
	"form-field": "FormView__form-field--2w24s",
	"formField": "FormView__form-field--2w24s"
};